import { toast } from 'react-toastify';
import { postApiCall } from '../Handlers/HttpHandler';

/**
 * GET /api/v1/enabled-casinos — no body required
 */
export const getEnabledCasinos = async (token) => {
  try {
    const result = await postApiCall('enabled-casinos', {}, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data ?? [];
  } catch { toast.error('Failed to load enabled casinos'); return null; }
};

/**
 * POST /api/v1/casino-categories  { brand }
 * Returns [{ id, key }]
 */
export const getCasinoCategories = async (token, brand) => {
  try {
    const result = await postApiCall('casino-categories', { brand }, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data ?? [];
  } catch { toast.error('Failed to load categories'); return null; }
};

/**
 * POST /api/v1/casino-integrators  { brand }
 * Returns string[]
 */
export const getCasinoIntegrators = async (token, brand) => {
  try {
    const result = await postApiCall('casino-integrators', { brand }, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data?.data ?? [];
  } catch { toast.error('Failed to load integrators'); return null; }
};

/**
 * POST /api/v1/casino-jurisdictions  { brand }
 * Returns string[]
 */
export const getCasinoJurisdictions = async (token, brand) => {
  try {
    const result = await postApiCall('casino-jurisdictions', { brand }, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data?.data ?? [];
  } catch { toast.error('Failed to load jurisdictions'); return null; }
};

/**
 * POST /api/v1/casino-providers  { brand }
 * Returns [{ key, title }]
 */
export const getCasinoProviders = async (token, brand) => {
  try {
    const result = await postApiCall('casino-providers', { brand }, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data?.data ?? [];
  } catch { toast.error('Failed to load casino providers'); return null; }
};

/**
 * POST /api/v1/casino-game-list
 * { aggregatorId, providerId, apiProviderName, casinoId, casinoProviderKey }
 */
export const getCasinoGameList = async (token, params) => {
  try {
    const result = await postApiCall('casino-game-list', params, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data ?? [];
  } catch { toast.error('Failed to load casino games'); return null; }
};

/**
 * POST /api/v1/casino-games-import
 * { casinoId, games: [{ operatorGameConfigId, providerKey, integrationKey,
 *   jurisdiction, platform, aspectRatio, description, tags, realMode, funMode,
 *   showInLobby, releaseDate, categoryKeys }] }
 */
export const importCasinoGames = async (token, payload) => {
  try {
    const result = await postApiCall('casino-games-import', payload, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data;
  } catch { toast.error('Failed to import casino games'); return null; }
};

/**
 * POST /api/v1/casino-game-thumbnails
 * { aggregatorId, operatorGameConfigId }
 * Returns ThumbnailDTO[] — [{ label, url }]
 */
export const getGameThumbnails = async (token, aggregatorId, operatorGameConfigId) => {
  try {
    const result = await postApiCall('casino-game-thumbnails', { aggregatorId, operatorGameConfigId }, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data ?? [];
  } catch { toast.error('Failed to load thumbnails'); return null; }
};

/**
 * POST /api/v1/casino-import-thumbnails
 * { casinoId, casinoGameId, imagesUrl: string[] }
 */
export const importGameThumbnails = async (token, payload) => {
  try {
    const result = await postApiCall('casino-import-thumbnails', payload, token);
    if (result.error) { toast.error(result.error?.message ?? result.error); return null; }
    return result.data;
  } catch { toast.error('Failed to import thumbnails'); return null; }
};

export async function getCategoryBonusTags(token, brand) {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}category-bonus-tags/list`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ brand }),
  });

  const data = await response.json();
  if (!response.ok || data?.error) return null;

  // PHP returns [] instead of {} for an empty map
  return data?.data && !Array.isArray(data.data) ? data.data : {};
}
